import { InputType, isMultiselectInput, isRangeInput } from 'dg-input-lib';
import { SurveyQuestionType } from './dg-questionnaire.constants';
import { SurveyQuestionConfigRestructured } from './dg-questionnaire.models';

export const mapSurveyQuestionTypeToDgDynamicInputType = (
  type: number
): number => {
  switch (type) {
    case SurveyQuestionType.RADIO:
      return InputType.RADIO;
    case SurveyQuestionType.TEXTBOX:
      return InputType.TEXT_AREA;
    case SurveyQuestionType.CHECKBOX:
      return InputType.CHECKBOX;
    case SurveyQuestionType.COMBOBOX:
      return InputType.DROPDOWN;
    case SurveyQuestionType.DATEBOX:
      return InputType.DATE;
    case SurveyQuestionType.TIMEBOX:
      return InputType.TIME;
    case SurveyQuestionType.LISTBOX:
      return InputType.MULTI_SELECT_DROPDOWN;
    case SurveyQuestionType.PASSWORD:
      return InputType.PASSWORD;
    case SurveyQuestionType.EMAIL:
      return InputType.EMAIL;
    case SurveyQuestionType.NUMBER:
      return InputType.NUMBER;
    case SurveyQuestionType.TEXT:
      return InputType.TEXT;
    case SurveyQuestionType.DATE_RANGE_BOX:
      return InputType.DATE_RANGE;
    case SurveyQuestionType.TIME_RANGE_BOX:
      return InputType.TIME_RANGE;
    default:
      return type;
  }
};

export const mapSurveyAnswerValueToCompatibleDgDynamicInputValue = (
  questionConfigRestructured: SurveyQuestionConfigRestructured
) => {
  if (!questionConfigRestructured?.answerVo) {
    let value = null;
    if (
      isRangeInput(questionConfigRestructured?.questionTypeForDgDynamicInput)
    ) {
      value = {
        from: null,
        to: null,
      };
    }
    return value;
  }
  if (questionConfigRestructured?.answerVo?.optionIds === '-1') {
    if (
      isRangeInput(questionConfigRestructured?.questionTypeForDgDynamicInput)
    ) {
      return JSON.parse(questionConfigRestructured?.answerVo?.answerText);
    }
    return questionConfigRestructured?.answerVo?.answerText;
  } else {
    if (
      isMultiselectInput(
        questionConfigRestructured?.questionTypeForDgDynamicInput
      )
    ) {
      return questionConfigRestructured?.optionMapRestructured?.filter(
        (option) =>
          questionConfigRestructured?.answerVo?.optionIds
            ?.toString()
            ?.trim()
            ?.split(',')
            ?.includes(option.optionId?.toString())
      );
    }
    return questionConfigRestructured?.optionMapRestructured?.find(
      (option) =>
        option.optionId?.toString() ===
        questionConfigRestructured?.answerVo?.optionIds?.toString()
    );
  }
};

export const getArrayFromObject = (obj: { [key: string]: any }): any[] =>
  Object?.keys(obj)?.map((key) => obj?.[key]);

export const getMapFromArray = (
  arr: any[],
  idKey: string
): { [key: string]: any } =>
  arr?.reduce(
    (prev, curr) => ({
      ...prev,
      [`${curr[idKey].toString()}`]: { ...curr },
    }),
    undefined
  );

export const getObjectFromArray = (arr: any[]): { [key: string]: any } =>
  [undefined, ...arr]?.reduce((prev, curr, index) => ({
    ...prev,
    [`${index}`]: { ...curr },
  }));

export const getFilteredPostData = (dataForPost) => {
  const tempQuestionMap = getArrayFromObject(dataForPost['questionMap']);
  const finalQueMap = [];
  tempQuestionMap.forEach((question) => {
    const tempQuestion = {
      questionId: question['questionId'],
      categoryId: question['categoryId'],
      questionType: question['questionType'],
      subQuestionMap: question['subQuestionMap'],
      optionMap: question['optionMap'],
      prntQuestionId: question['prntQuestionId']
        ? question['prntQuestionId']
        : 0, //dynamic
    };
    finalQueMap.push(tempQuestion);
  });
  dataForPost['questionMap'] = getMapFromArray(finalQueMap, 'questionId');
  const filteredData = {
    surveyId: dataForPost['surveyId'],
    surveyTypeId: dataForPost['surveyTypeId'],
    surveyDtlId: dataForPost['surveyDtlId'],
    stakeHolderId: dataForPost['stakeHolderId'],
    stakeHolderTypeId: dataForPost['stakeHolderTypeId'],
    lTemplateId: dataForPost['lTemplateId'],
    surveyResponseVO: {
      status: dataForPost['surveyResponseVO']?.status
        ? dataForPost['surveyResponseVO']?.status
        : null,
      surveyRespTrnId: dataForPost['surveyResponseVO']?.surveyRespTrnId
        ? dataForPost['surveyResponseVO']?.surveyRespTrnId
        : null,
    },
    questionMap: dataForPost['questionMap'],
  };
  return filteredData;
};

export const getCategorywiseArray = (
  questionList: SurveyQuestionConfigRestructured[]
): any[] => {
  let categoryArrayList = [];
  let i = 0;
  let newflag = 1;
  let subArr = [];
  while (i < questionList?.length) {
    if (newflag == 1) {
      subArr = [questionList[i]];
      newflag = 0;
    }
    if (
      i + 1 < questionList?.length &&
      questionList?.[i]?.categoryId &&
      questionList?.[i + 1]?.categoryId &&
      questionList?.[i]?.categoryId == questionList?.[i + 1]?.categoryId
    ) {
      subArr.push(questionList?.[i + 1]);
    } else {
      newflag = 1;
      categoryArrayList.push(subArr);
    }
    i = i + 1;
  }
  return categoryArrayList;
};

export const findQuestionInCatArray = (
  questionId: number | string,
  catArrayList: SurveyQuestionConfigRestructured[][]
): { index: number; questionData: SurveyQuestionConfigRestructured | null } => {
  let findJson = {
    index: -1,
    questionData: null,
  };
  for (let i = 0; i < catArrayList.length; i++) {
    const index = catArrayList[i].findIndex(
      (que) => Number(que.questionId) === Number(questionId)
    );
    if (index > -1) {
      findJson.index = index;
      findJson.questionData = catArrayList[i][index];
      return findJson;
    }
  }
  return findJson;
};
